import BaseApi from "./BaseApi";

class WaitListCoupleApi extends BaseApi {


  async waitListCouplesData(data) {
    return await this.API({
      url: "/waitList//wait-list-couples-data",
      data: data,
      method: "post",
    });
  }
}

export default WaitListCoupleApi;
